/** Guias de ajuda do app Tricolab: um por tela (e um por etapa do check-up). Atualizar quando a tela mudar. */
export const AJUDA = {
  lista: { titulo: "Suas clientes", passos: [
    "Aqui ficam todas as clientes que você atende com o Tricolab. Só você vê as suas.",
    "Use a busca para achar pelo nome ou pelo telefone.",
    "Toque em “Nova cliente” para cadastrar alguém.",
    "Toque no nome da cliente para ver o prontuário e começar um check-up.",
    "Em “Meu salão”, preencha o nome do salão, o WhatsApp e o endereço: eles saem no relatório da cliente.",
  ], dica: "Instale o app no celular pelo botão “Instalar”: ele ganha um ícone próprio na sua tela." },
  perfil: { titulo: "Meu salão", passos: [
    "Preencha o nome do salão, o WhatsApp e o endereço com a cidade.",
    "Esses dados saem no relatório da cliente e na ficha completa, junto com o seu nome como profissional responsável.",
    "Toque em “Salvar”. Você pode mudar quando quiser.",
  ], dica: "O WhatsApp no relatório ajuda a cliente a voltar e marcar a reavaliação." },
  nova: { titulo: "Cadastrar cliente", passos: [
    "Preencha o nome da cliente. É o único campo obrigatório.",
    "O telefone ajuda a achar a cliente depois e a mandar o relatório pelo WhatsApp.",
    "Toque em “Salvar cliente”. Você vai direto para a página dela.",
  ] },
  cliente: { titulo: "Prontuário da cliente", passos: [
    "Toque em “Novo check-up Tricolab” para começar um atendimento.",
    "No prontuário ficam todos os check-ups, com a data e a reavaliação marcada.",
    "Check-up em “rascunho” ainda pode ser editado. “Validado” fica travado.",
    "Com dois check-ups validados, aparece a “Evolução”: o antes e o depois de cada teste e das fotos.",
    "Se a cliente pedir para apagar os dados dela, use “Excluir cliente”, no fim da página. Isso apaga tudo de vez.",
  ] },
  passo0: { titulo: "Etapa 1: anamnese", passos: [
    "Escolha a identificação da mecha: virgem, descolorido, colorido, com alisamento, neutralizado ou com incompatibilidade química.",
    "Preencha o histórico: químicas, tratamentos, piscina ou mar, calor, produtos de casa, queixa e objetivo.",
    "Tire as 3 fotos (frente, lado e costas) tocando nos quadros. Só com a autorização da cliente.",
    "Tudo é salvo sozinho enquanto você escreve. Depois toque em “Próxima etapa”.",
  ], dica: "As fotos de frente aparecem na Evolução, para mostrar o resultado nas próximas visitas." },
  passo1: { titulo: "Etapa 2: termo de autorização", passos: [
    "Leia o termo com a cliente.",
    "Ela assina com o dedo no quadro branco.",
    "Toque em “Confirmar assinatura”. Se errar, use “Limpar” e peça para assinar de novo.",
  ], dica: "Sem a assinatura não dá para validar o protocolo no final." },
  passo2: { titulo: "Etapa 3: os 7 testes", passos: [
    "Faça cada teste do kit e toque na cor que você viu.",
    "Na hora aparece o que a cor significa, pela tabela oficial do Tricolab.",
    "Em “Preparo, ficha, foto e observações” estão o modo de preparo, os campos da ficha e a foto do teste.",
    "Depois dos 7 testes, siga para a interpretação.",
  ], dica: "Leia a cor sobre um fundo branco e mantenha sempre a mesma quantidade de gotas." },
  passo3: { titulo: "Etapa 4: interpretação", passos: [
    "Os alertas em vermelho ou amarelo pedem avaliação antes de química ou tratamento.",
    "As prioridades mostram o que fazer primeiro: sempre desmineralizar antes das químicas e dos tratamentos.",
    "A tabela embaixo resume a leitura e a conduta de cada teste.",
  ], dica: "É uma avaliação cosmética da fibra, não um diagnóstico médico." },
  passo4: { titulo: "Etapa 5: formulação", passos: [
    "Escolha a base e a quantidade final da fórmula, em gramas.",
    "Em cada necessidade (porosidade, proteína, lipídica), marque até 5 ativos. Não precisa usar todos.",
    "O app calcula os gramas de cada ativo pela concentração da tabela e mostra o pH e o reagente.",
    "Leia os avisos da fórmula proposta antes de seguir.",
  ], dica: "A decisão final é sempre sua: o app orienta, você escolhe." },
  passo5: { titulo: "Etapa 6: prontuário e relatório", passos: [
    "Escreva a conduta e as orientações para a cliente.",
    "Marque a data da reavaliação.",
    "Toque em “Validar e salvar protocolo”. Depois disso ele não muda mais.",
    "Toque em “Enviar relatório para a cliente”: no celular abre o compartilhar com o PDF anexado. Escolha o WhatsApp e a conversa da cliente.",
    "“Baixar relatório” salva o PDF da cliente. “Ficha completa” é o seu registro técnico, com anamnese, termo, fotos dos testes e a fórmula em gramas.",
  ], dica: "Para mudar algo depois de validado, faça um novo check-up: assim a evolução fica registrada." },
};
